<app-modal [(visible)]="show" [title]="'New Company'">

    <app-new-button #modalShow ngProjectAs="modal-show"/>

    <div #modalContent ngProjectAs="modal-content">

        <div class="mb-4">
            <p class="font-light">Create a new company by filling in the following fields.</p>
        </div>

        <form [formGroup]="form()" (ngSubmit)="onSubmit()">

            <app-form-control [(control)]="form().controls.organisation" [type]="'select'" [options]="organisationOptions()"/>
            <app-form-control [(control)]="form().controls.ofsCompany" [type]="'select'" [options]="ofsCompanyOptions()"/>

            <app-modal-form-button-group [buttons]="['submit']" [form]="form()" 
                [opts]="{
                    values:{
                        submit: 'Create'
                    }
                }"
           />

        </form>    
    </div>

</app-modal>